<template>
    <div :class="{ 'form-check': !useFormLayout, 'eq-form-row-check': useFormLayout }">
        <label
            class="text-nowrap form-check-label"
            :class="{ 'eq-form-label': useFormLayout }"
            :for="guid"
        >
            <input
                ref="inputref"
                class="ag-input-field-input ag-checkbox-input form-check-input"
                type="checkbox"
                v-model="modelValue"
                :disabled="disabled"
                :id="guid"
            />
            <div class="d-flex gap-3 flex-nowrap">
                <MarkText
                    v-if="prop.label"
                    :text="$tm(prop.label)"
                    :markPart="prop.markTextPart"
                    :class="{ 'opacity-50': disabled }"
                />

                <span
                    class="display-6 align-self-center"
                    v-if="subtext"
                >
                    {{ $tm(subtext) }}
                </span>

                <TooltipHelp
                    v-if="tooltip"
                    :text="tooltip"
                    class="ms-auto"
                />

                <div
                    class="ms-auto position-relative"
                    v-if="rightDotColor"
                >
                    <span
                        class="position-absolute top-50 translate-middle p-2 me-2 rounded-circle"
                        :style="{ 'background-color': normalizeHexColor(rightDotColor) }"
                    />
                </div>
            </div>
        </label>
    </div>
</template>
<script setup lang="ts">
import { randomstring } from '@/utilities/utils';
import { type IInputBoolModelValueType, TooltipHelp, type IInputBoolPropsWithoutModelValue } from '@/components';
import { ref } from 'vue';
import { normalizeHexColor } from '@/utilities/colorUtils';
import MarkText from '../MarkText/MarkText.vue';

const prop = withDefaults(defineProps<IInputBoolPropsWithoutModelValue>(), {
    label: '',
    tooltip: null,
    disabled: false,
    useFormLayout: false,
});

const modelValue = defineModel<IInputBoolModelValueType>({ required: true });

const inputref = ref<HTMLInputElement | null>();

const guid = randomstring('cb-', '-');

defineExpose({ focus: () => inputref.value?.focus() });
</script>
